export const SET_SHIPMENT_TYPE = 'SET_SHIPMENT_TYPE'
export const setShipmentType = (shipmentType) => ({type: 'SET_SHIPMENT_TYPE', shipmentType})

export const SET_AVAILABLE_BOOKING_DATES = 'SET_AVAILABLE_BOOKING_DATES'
export const setAvailableBookingDates = (availableBookingDates) => ({type: SET_AVAILABLE_BOOKING_DATES, availableBookingDates})
